import { createReducer } from '@reduxjs/toolkit'

import type { TAttributeOptionDto } from '@homepal/api-contract'

import { insertItems } from 'redux/utils'
import { groupBy } from 'utils/functions'

import * as actions from '../../actions/AttributeOptions/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface AttributeOptionsReducerType {
  data: { [id: string]: TAttributeOptionDto }
  optionsByFactTableId: { [factTableId: string]: TAttributeOptionDto[] }
  fetched: boolean
}

const INITIAL_STATE: AttributeOptionsReducerType = {
  data: {},
  optionsByFactTableId: {},
  fetched: false
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = insertItems(action.payload)
      state.optionsByFactTableId = groupBy(action.payload, 'fact_table_id')
      state.fetched = true
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
